var _linearGradient, _linearGradient2, _linearGradient3, _g, _path, _path2, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxJinx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "1em",
    viewBox: "0 0 647 426",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_jinx_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 361,
    x2: 361,
    y1: 272.5,
    y2: 425.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#2b4d8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_jinx_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 466.5,
    x2: 646.5,
    y1: 229,
    y2: 229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#006837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_jinx_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 453.5,
    x2: 453.5,
    y1: 147.212,
    y2: -0.788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#c45631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 82L88 251l29 7 65-173zM196 86l-65 175 29 6 45-119 19 133 36 8 72-190-35.5-3.5-47 126-20-132zM348.5 100.5L338 130.4l37.5 76.1-88 57-11 29 27 6 89-56 42 83 32 8 13-34-45-84 101-63 12-34-32-3-98 63-40-76z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.5 417.5l34-91-34-7.8 77-46.2 34 71-36-8-34 90z",
    fill: "url(#ix_jinx_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5 166.5l-86 54 39 71 15-39 114.4 20 11.6-52L538.6 205z",
    fill: "url(#ix_jinx_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.5 84l34 64 82-54-38-3 34-91H463l-32.9 86.5z",
    fill: "url(#ix_jinx_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 73.5l-60 159 74 17 63-169z",
    fill: "#de9a01",
    fillOpacity: 0.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 221.4l3.6-7.2L43.8 192l-14.7-3.2 3.3-6.7 23 5-3.1 6.2-30.4 23 17.9 3.9-3.3 6.7zM69 234l-6.9-1.5 1.7-9.6-12.6-2.7-7 8.5-6.7-1.5 31.8-37 6.7 1.5zm-4-18.3l2.9-15.7-11.5 13.8z"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgIxJinx as ReactComponent };